import React from 'react';

export function ProjectEquipmentUpcomingMaintenance({ maintenance }: { maintenance: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Sắp tới bảo dưỡng</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Xem tất cả</button>
      </div>

      <div className="space-y-4">
        {maintenance.map((m) => (
          <div key={m.id} className="flex gap-3 group cursor-pointer">
             <div className="w-8 h-8 rounded-md bg-slate-50 flex items-center justify-center shrink-0 group-hover:bg-amber-50 transition-colors">
                <i className="ri-tools-line text-slate-400 group-hover:text-amber-500" />
             </div>
             <div className="space-y-0.5 min-w-0 flex-1">
                <h4 className="text-xs font-normal text-slate-700 truncate group-hover:text-emerald-600 transition-colors">{m.name}</h4>
                <p className="text-xs font-normal text-slate-400">{m.code}</p>
                <div className="flex justify-between items-center text-xs font-normal mt-1">
                   <span className="text-slate-400">{m.date}</span>
                   <span className="text-rose-500">{m.remaining}</span>
                </div>
             </div>
          </div>
        ))}
      </div>
    </div>
  );
}
